var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1194_6750",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1194_6750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.0833V9.18326H13.7667V15.0833H2.25ZM3.81667 12.1666H12.1833V10.7499H3.81667V12.1666ZM8 9.18326L4.28333 4.73325C4.28333 3.68881 4.64283 2.78881 5.36183 2.03325C6.08083 1.2777 6.96022 0.899921 8 0.899921C9.03978 0.899921 9.91917 1.2777 10.6382 2.03325C11.3572 2.78881 11.7167 3.68881 11.7167 4.73325L8 9.18326ZM8 6.89992L10.05 4.23325C9.96111 3.7407 9.72467 3.32587 9.34067 2.98876C8.95667 2.65176 8.50944 2.48325 7.999 2.48325C7.48856 2.48325 7.04167 2.65176 6.65833 2.98876C6.275 3.32587 6.03889 3.7407 5.95 4.23325L8 6.89992Z",
    fill: "#172128"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.3a4e33667b21ba89bd3c6c9b3922b3e7.svg";
export { ForwardRef as ReactComponent };